import { Navigate, Route } from "@solidjs/router";
import { type ParentProps, Show } from "solid-js";
import { useAuth } from "./auth/AuthContext.tsx";
import { AppShell } from "./components/AppShell.tsx";
import { Approvals } from "./pages/Approvals.tsx";
import { Buy } from "./pages/Buy.tsx";
import { BuyComplete } from "./pages/BuyComplete.tsx";
import { ConfirmTotp } from "./pages/ConfirmTotp.tsx";
import { Dashboard } from "./pages/Dashboard.tsx";
import { History } from "./pages/History.tsx";
import { Login } from "./pages/Login.tsx";
import { Register } from "./pages/Register.tsx";
import { Send } from "./pages/Send.tsx";
import { SubWallets } from "./pages/SubWallets.tsx";

/** Gate the app behind a live session; otherwise redirect to /login. */
function ProtectedShell(props: ParentProps) {
  const { session } = useAuth();
  return (
    <Show when={session()} fallback={<Navigate href="/login" />}>
      <AppShell>{props.children}</AppShell>
    </Show>
  );
}

/** Top-level route table. Auth-required routes share the {@link AppShell}. */
export function App() {
  return (
    <>
      <Route path="/login" component={Login} />
      <Route path="/register" component={Register} />
      <Route path="/confirm-totp" component={ConfirmTotp} />
      <Route path="/" component={ProtectedShell}>
        <Route path="/" component={Dashboard} />
        <Route path="/send" component={Send} />
        <Route path="/sub-wallets" component={SubWallets} />
        <Route path="/approvals" component={Approvals} />
        <Route path="/history" component={History} />
        <Route path="/buy" component={Buy} />
        <Route path="/buy/complete" component={BuyComplete} />
        <Route path="*" component={() => <Navigate href="/" />} />
      </Route>
    </>
  );
}
